module.exports = __webpack_public_path__ + "img/text2@3x.1507e037.png";